export const getTitle = (pageName?: string) => {
  return pageName ? `${pageName} - Wildscreen ARK` : 'Wildscreen ARK';
};
